import { ActionReducer, ActionReducerMap, MetaReducer } from '@ngrx/store';
import { environment } from '../../environments/environment';
import { routerReducer, RouterReducerState } from '@ngrx/router-store';
import { appSettingsReducer, AppSettingsState } from './app-settings.reducer';

export interface AppState {
  appSettings: AppSettingsState;
  router: RouterReducerState;
}

export const reducers: ActionReducerMap<AppState> = {
  appSettings: appSettingsReducer,
  router: routerReducer,
};

export function logger(reducer: ActionReducer<any>): ActionReducer<any> {
  return (state, action) => {
    console.log('state before: ', state);
    console.log('action', action);

    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<AppState>[] = !environment.production ? [logger] : [];
